import { useCallback } from 'react';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { DraftPrescriptionsFormController } from '../../draftPrescriptions/DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../../draftPrescriptions/standardPrescription/DraftStandardPrescriptionField.types';
import { AdditionalRequirement } from '../additionalRequirements/additionalRequirements.types';

import { StyledChangeToPrescriptionForYearLink } from './ChangeToPrescriptionForYearLink.styled';

const FOR_YEAR_ADDITIONAL_REQUIREMENT: AdditionalRequirement = { type: 'FOR_YEAR' };

type ChangeToPrescriptionForYearLinkProps = Pick<DraftPrescriptionsFormController, 'setValue'> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly additionalRequirements: AdditionalRequirement[] | null | undefined;
};

export const ChangeToPrescriptionForYearLink = (props: ChangeToPrescriptionForYearLinkProps): JSX.Element => {
   const handleClick = useCallback(() => {
      props.setValue(props.name, [...(props.additionalRequirements ?? []), FOR_YEAR_ADDITIONAL_REQUIREMENT], {
         shouldValidate: true,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.setValue, props.name, props.additionalRequirements]);

   return (
      <StyledChangeToPrescriptionForYearLink
         testId={'changeToPrescriptionForYear'}
         label={prescriptionTranslationKeys.numericalDosage.changeToPrescriptionForYear}
         onClick={handleClick}
         block={false}
      />
   );
};
